import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LfRoutes} from '@lightweightform/core';
import {IntermediaryFormComponent} from './intermediary-form/intermediary-form.component';
import {IntermediaryComponent} from './intermediary.component';


const routes: LfRoutes = [
  {
    path: '',
    component: IntermediaryComponent,
    children: [
      {path: '', redirectTo: 'intermediary-form', pathMatch: 'full'},
      {path: 'intermediary-form', component: IntermediaryFormComponent},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
